<template>
  <div>
    <div
      class="modal fade"
      ref="reviewModal"
      id="reviewModal"
      tabindex="-1"
      aria-labelledby="reviewModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 rounded-4 overflow-hidden shadow-lg">

          <!-- Close button -->
          <button
            type="button"
            class="btn-close position-absolute top-0 end-0 m-3"
            style="z-index:10;opacity:0.4;"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>

          <div class="modal-body px-4 pt-5 pb-4">

            <!-- Thank you state -->
            <div v-if="finished" class="text-center py-3">
              <div class="d-flex align-items-center justify-content-center bg-dark text-white rounded-circle mx-auto mb-3"
                style="width:3.5rem;height:3.5rem;font-size:1.25rem;">
                <i class="fas fa-check"></i>
              </div>
              <h5 class="fw-bold mb-1">{{ 'Thank you!' | translate }}</h5>
              <p class="text-muted small mb-0">{{ 'Your review has been submitted.' | translate }}</p>
            </div>

            <!-- Rating state -->
            <div v-else>
              <div class="d-flex align-items-center justify-content-center bg-dark text-white rounded-circle mx-auto mb-3"
                style="width:3.5rem;height:3.5rem;font-size:1.25rem;">
                <i class="fas fa-star"></i>
              </div>

              <h5 class="text-center fw-bold mb-1">{{ 'Leave a review' | translate }}</h5>
              <p class="text-center text-muted small mb-4">{{ 'Would you recommend this product to others?' | translate }}</p>

              <div class="d-flex justify-content-center gap-3 mb-2">

                <div class="text-center flex-grow-1">
                  <button
                    @click="rating = 10"
                    class="btn rounded-3 px-3 py-2 w-100"
                    :class="rating === 10 ? 'btn-dark' : 'btn-outline-secondary'"
                  >
                    <i class="far fa-smile fa-2x d-block mb-1"></i>
                    <span class="small">{{ 'Yes' | translate }}</span>
                  </button>
                </div>

                <div class="text-center flex-shrink-1">
                  <button
                    @click="rating = 5"
                    class="btn rounded-3 px-3 py-2 w-100"
                    :class="rating === 5 ? 'btn-dark' : 'btn-outline-secondary'"
                  >
                    <i class="far fa-meh fa-2x d-block mb-1"></i>
                    <span class="small">{{ 'Not sure' | translate }}</span>
                  </button>
                </div>

                <div class="text-center flex-grow-1">
                  <button
                    @click="rating = 1"
                    class="btn rounded-3 px-3 py-2 w-100"
                    :class="rating === 1 ? 'btn-dark' : 'btn-outline-secondary'"
                  >
                    <i class="far fa-frown fa-2x d-block mb-1"></i>
                    <span class="small">{{ 'No' | translate }}</span>
                  </button>
                </div>

              </div>

              <div class="mt-4" v-if="rating">
                <label class="form-label small fw-semibold">{{ 'Why did you choose that answer?' | translate }}</label>
                <textarea class="form-control rounded-3" rows="3" v-model="review"></textarea>
              </div>

              <div class="mt-3" v-if="rating">
                <button
                  @click.prevent="submit"
                  type="button"
                  class="btn btn-dark w-100 rounded-3 fw-semibold py-2"
                >
                  {{ 'Submit' | translate }}
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  data: () => ({
    modal: null,
    rating: null,
    review: null,
    finished: false,
  }),
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.reviewModal)
  },
  methods: {
    close() {
      this.modal.hide()
    },
    submit() {
      axios
        .post(`/${this.course.id}/review`, {
          rating: this.rating,
          review: this.review,
        })
        .then(() => {
          this.finished = true
        })
        .catch(error => {
          let status = _.get(error, 'response.status')

          if (status === 403) {
            this.close()
          }
        })
    },
  },
  computed: {
    course() {
      return this.$store.state.course
    },
  },
}
</script>
